import {FC} from 'react'
import {KTIcon} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {Product} from '../core/_models'
import {useListView as invoiceUseListView} from '../../../invoice-management/invoices-list/core/ListViewProvider'

type Props = {
  product?: Product
}

const ProductEditModalHeader: FC<Props> = ({product}) => {
  const {setItemIdForUpdate} = useListView()
  const {setvariableC} = invoiceUseListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>{product ? product.nm : 'کالا/خدمت جدید'}</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <button
        type='button'
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-products-modal-action='close'
        onClick={() => {
          setItemIdForUpdate(undefined)
          setvariableC(undefined)
        }}
        aria-label='بستن فرم کالا/خدمت'
      >
        <KTIcon iconName='cross' className='fs-1' />
      </button>
      {/* end::Close */}
    </div>
  )
}

export {ProductEditModalHeader}
